<!-- @format -->
<template>
  <a
    v-if="$config.youtube.display === true"
    :href="$config.youtube.link"
    target="_blank"
    class="m-trailer external"
  >
    <div class="m-trailer__wrapper">
      <video
        src="@/assets/videos/sizzle.mp4"
        loop
        muted
        autoplay
        playsinline
      ></video>
      <div class="m-trailer__text-wrapper">
        <img src="@/assets/images/trailer/play.png" alt="" />
        <div class="m-trailer__text">
          {{ $t('index.trailer') }}
        </div>
      </div>
    </div>

    <p class="m-trailer__note">
      Quelle: Youtube<br />
      {{ $t('trailer.text') }}
    </p>
  </a>
</template>

<script>
  export default {}
</script>

<style lang="scss">
  .m-trailer {
    $self: &;
    position: relative;
    background: $primary;
    padding: 5%;
    display: block;
    &__wrapper {
      position: relative;
      cursor: pointer;
      border: 5px solid white;
      video {
        width: 100%;
      }
      #{$self}__text-wrapper {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 111;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        #{$self}__text {
          font-weight: 700;
          color: white;
          text-transform: uppercase;
          margin-top: 1rem;
        }
      }
    }
    &__note {
      font-size: 0.8rem;
      color: white;
      margin-top: 1rem;
    }
  }
</style>
